// Author liang gang qiang
// Date 2021-11-18 16:39:58

import * as model from "@/model/mintalMes/prd/MintalMesPrdShiftPlanModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.MintalMesPrdShiftPlan(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_MINTALMES_PRD_URL,
        selectRowsToItems: function (row) {
            return {value: row.id, text: row.code}
        },
    })
    .buildStore()
